module.exports = __webpack_public_path__ + "img/feature_10.ba9a96bc.svg";